import React, { useEffect, useState } from 'react';
import './Certifications.css';
import { FaUniversity, FaMicrosoft, FaGoogle } from 'react-icons/fa';
import { SiUdemy, SiCoursera, SiIeee } from 'react-icons/si';
import { Certification } from '../types';
import { getCertifications } from '../queries/getCertifications';

// Define the available categories
type Category = 'IT' | 'Water & WasteWater';

const iconData: { [key: string]: JSX.Element } = {
  'udemy': <SiUdemy />,
  'coursera': <SiCoursera />,
  'ieee': <SiIeee />,
  'university': <FaUniversity />,
  'google': <FaGoogle />,
  'microsoft': <FaMicrosoft />,
}

const Certifications: React.FC = () => {

  const [certifications, setCertifications] = useState<Certification[]>([]);
  // New state to track the active category (default to 'IT')
  const [activeCategory, setActiveCategory] = useState<Category>('IT');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCertifications() {
      setLoading(true);
      // Pass the active category to the fetch function
      // NOTE: Ensure getCertifications.ts is updated to accept this filter
      const data = await getCertifications(activeCategory as 'IT' | 'Water & WasteWater');
      setCertifications(data);
      setLoading(false);
    }

    fetchCertifications();
    // Re-run the effect whenever the activeCategory changes
  }, [activeCategory]);

  return (
    <div className="certifications-container">
      <div className="quote">
        <p>An overview of the professional certifications I have gained.</p>
      </div>


      {/* New Category/Tab Buttons using the genre-card style */}
      <div className="category-tabs">
        {/* Changed class name to genre-card */}
        <button
          className="genre-card"
          onClick={() => setActiveCategory('IT')}
          // Added a data attribute to control active styling in CSS
          data-active={activeCategory === 'IT'}
          style={{ animationDelay: '0s' } as React.CSSProperties}
        >
          <p>IT</p>
        </button>
        {/* Changed class name to genre-card */}
        <button
          className="genre-card"
          onClick={() => setActiveCategory('Water & WasteWater')}
          data-active={activeCategory === 'Water & WasteWater'}
          style={{ animationDelay: '0.2s' } as React.CSSProperties}
        >
          <p>Water & WasteWater</p>
        </button>
      </div>

      {/* Loading state check */}
      {loading ? (
        <div className="loading-state">Loading {activeCategory} certifications...</div>
      ) : certifications.length === 0 ? (
        <div className="loading-state">No {activeCategory} certifications found.</div>
      ) : (
        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <a
              href={cert.link}
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              className="certification-card"
              style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}
            >
              <div className="certification-content">
                <div className="certification-icon">{iconData[cert.iconName] || <FaUniversity />}</div>
                <h3>{cert.title}</h3>
                <p>{cert.issuer}</p>
                {cert.issuedDate && <span className="issued-date">Issued {cert.issuedDate}</span>}
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default Certifications;